export default {
	title: 'Strategischer Plan',
	tabs: {
		general: {
			title: 'Allgemein'
		},
		filters: {
			title: 'Ansichtsfilter'
		},
		bot: {
			title: 'KI'
		},
		export: {
			title: 'Exportieren'
		},
		display: {
			title: 'Anzeige'
		}
	},
	filters: {
		responsible: {
			title: 'Filter nach Verantwortlichem',
			placeholder: 'Name des Verantwortlichen'
		},
		completion: {
			title: 'Vollständigkeits-Filter',
			not_started: 'Nicht begonnen',
			in_progress: 'In Bearbeitung',
			completed: 'Abgeschlossen'
		},
		dates: {
			title: 'Daten-Filter'
		},
		startOn: {
			title: 'Startdatum-Filter',
			undefined: 'Kein Datum',
			past: 'Vergangenheit',
			ending_week: 'Beginnt in einer Woche',
			ending_month: 'Beginnt in einem Monat',
			ending_quarter: 'Beginnt in einem Quartal',
			ending_year: 'Beginnt in einem Jahr'
		},
		endOn: {
			title: 'Enddatum-Filter',
			undefined: 'Kein Datum',
			done: 'Erledigt',
			overdue: 'Überfällig',
			ending_week: 'Endet in einer Woche',
			ending_month: 'Endet in einem Monat',
			ending_quarter: 'Endet in einem Quartal',
			ending_year: 'Endet in einem Jahr'
		}
	},

	display: {
		sort: {
			title: 'Sortierung der Äste',
			startOn: 'Nach Startdatum',
			name: 'Nach Name',
			manual: 'Manuell'
		}
	},
	all_icons: 'Symbol-Filter',
	no_icon: 'Kein Symbol',
	onboarding: {
		title: 'Aktionsplan-Review',
		description:
			'Prüfen Sie, ob Achsen und Items zu Ihrer Lesart des Plans passen.'
	}
};
